import * as React from 'react';
const SvgRadius = props => (
  <svg
    fill="currentColor"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M10 .017c-5.525 0-10 4.475-10 10s4.475 10 10 10 10-4.475 10-10-4.475-10-10-10m0 18.75c-4.825 0-8.75-3.925-8.75-8.75s3.925-8.75 8.75-8.75 8.75 3.925 8.75 8.75-3.925 8.75-8.75 8.75" />
  </svg>
);
export default SvgRadius;
